import { Configuration, BrowserCacheLocation, IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration, MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

// DEBUG: Log MSAL config values at module load time
console.log('🔍 MSAL CONFIG DEBUG - environment.redirectUri:', environment.redirectUri);
console.log('🔍 MSAL CONFIG DEBUG - environment.clientId:', environment.clientId);
console.log('🔍 MSAL CONFIG DEBUG - Using redirectUri directly (no fallback):', environment.redirectUri);

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.clientId,
    authority: `https://login.microsoftonline.com/${environment.tenantId}`,
    knownAuthorities: ['login.microsoftonline.com'],
    redirectUri: environment.redirectUri,
    postLogoutRedirectUri: environment.postLogoutRedirectUri,
    navigateToLoginRequestUrl: false, // Don't navigate back to original request URL
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage, // Use session storage for better redirect handling
    storeAuthStateInCookie: true, // Enable for IE11 support
  },
  system: {
    allowRedirectInIframe: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        console.log(message);
      },
      logLevel: 3, // Info level for debugging
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const protectedResources = {
  // Only protect specific endpoints that require authentication
  // Exclude /api/v1/auth/* endpoints as they handle their own auth
  passports: {
    endpoint: environment.apiUrl + '/api/v1/passports',
    scopes: ['user.read'],
  },
  users: {
    endpoint: environment.apiUrl + '/api/v1/users',
    scopes: ['user.read'],
  },
  // Add other protected endpoints as needed
};

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

/** MSAL v4+ requires initialize() before acquireTokenSilent, loginRedirect, etc. */
export function msalInitializerFactory(msalService: MsalService): () => Promise<void> {
  return () => msalService.instance.initialize();
}

export function MsalGuardConfigurationFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: loginRequest,
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      [protectedResources.passports.endpoint, protectedResources.passports.scopes],
      [protectedResources.users.endpoint, protectedResources.users.scopes],
      // Auth endpoints (/api/v1/auth/*) are NOT included here
      // They handle their own authentication
    ]),
  };
}


